export function isEvening() {
  const hour = new Date().getHours();
  return hour >= 20 && hour < 24;
}

export function isNight() {
  const hour = new Date().getHours();
  return hour >= 0 && hour < 7;
}

export function isSunday() {
  const day = new Date().getDay();
  return day === 0;
}

export function isFriday() {
  const day = new Date().getDay();
  return day === 5;
}
